module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0141.jpg?v=6c7ff398";